import React, { useState, useEffect, useRef } from 'react';
import SearchHeader from '../components/SearchHeader';
import TopNav from '../components/TopNav';
import SkillsMatrix from '../components/SkillsMatrix';
import ContextSearchResults from '../components/ContextSearchResults';
import { darkPurple } from '../utils/colors';
import { searchSkills } from '../utils/api';

export default function SkillsMatrixPage({ apiBase }) {
  const [search, setSearch] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [searchLoading, setSearchLoading] = useState(false);
  const [searchDropdown, setSearchDropdown] = useState(false);
  const [expandedDescId, setExpandedDescId] = useState(null);
  const searchTimeout = useRef();
  const searchInputRef = useRef();

  // Функция поиска с debounce
  useEffect(() => {
    if (!apiBase || !search.trim()) {
      setSearchResults([]);
      setSearchLoading(false);
      return;
    }

    setSearchLoading(true);
    
    // Очищаем предыдущий таймаут
    if (searchTimeout.current) {
      clearTimeout(searchTimeout.current);
    }

    // Устанавливаем новый таймаут для debounce
    searchTimeout.current = setTimeout(async () => {
      try {
        console.log('Выполняем поиск в матрице:', search.trim());
        const results = await searchSkills(apiBase, search.trim());
        console.log('Результаты поиска в матрице:', results);
        setSearchResults(Array.isArray(results) ? results : []);
        setSearchDropdown(true);
      } catch (e) {
        console.error('Ошибка поиска в матрице:', e);
        setSearchResults([]);
      } finally {
        setSearchLoading(false);
      }
    }, 300); // 300ms debounce

    return () => {
      if (searchTimeout.current) {
        clearTimeout(searchTimeout.current);
      }
    };
  }, [search, apiBase]);

  // Обработчик клика на результат поиска - переходим на страницу навыка
  const handleSearchResultClick = async (searchResult) => {
    console.log('Переходим к навыку из матрицы:', searchResult);
    try {
      // Очищаем состояние поиска
      setSearch("");
      setSearchResults([]);
      setSearchDropdown(false);
      
      // Переходим на страницу деталей навыка
      const newHash = `#/skill/${searchResult.id}`;
      console.log('Устанавливаем hash:', newHash);
      window.location.hash = newHash;
      
      // Дополнительно принудительно обновляем роутинг
      setTimeout(() => {
        window.dispatchEvent(new HashChangeEvent('hashchange'));
      }, 100);
      
      console.log('Навигация к навыку выполнена');
    } catch (error) {
      console.error('Ошибка при навигации к навыку:', error);
    }
  };

  // Функции для подсветки текста
  const highlight = (text, searchTerm) => {
    if (!searchTerm) return text;
    const regex = new RegExp(`(${searchTerm})`, 'gi');
    return text.replace(regex, '<mark style="background: yellow; color: black;">$1</mark>');
  };

  const getSnippet = (text, searchTerm) => {
    if (!searchTerm || !text) return text;
    const index = text.toLowerCase().indexOf(searchTerm.toLowerCase());
    if (index === -1) return text.substring(0, 100) + '...';
    
    const start = Math.max(0, index - 50);
    const end = Math.min(text.length, index + searchTerm.length + 50);
    return (start > 0 ? '...' : '') + text.substring(start, end) + (end < text.length ? '...' : '');
  };

  return (
    <div className="App" style={{ background: darkPurple, minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <SearchHeader
        search={search}
        setSearch={setSearch}
        searchInputRef={searchInputRef}
        setSearchDropdown={setSearchDropdown}
        searchDropdown={searchDropdown}
      >
        <ContextSearchResults
          search={search}
          searchDropdown={searchDropdown}
          searchLoading={searchLoading}
          searchResults={searchResults}
          expandedDescId={expandedDescId}
          setExpandedDescId={setExpandedDescId}
          onResultClick={handleSearchResultClick}
          setSearchDropdown={setSearchDropdown}
          setSearch={setSearch}
          searchInputRef={searchInputRef}
          getSnippet={getSnippet}
          highlight={highlight}
          currentPage="matrix"
        />
      </SearchHeader>
      <TopNav current="matrix" />
      <div style={{ padding: 12 }}>
        <SkillsMatrix apiBase={apiBase} />
      </div>
    </div>
  );
}

